import { Component, forwardRef, input } from "@angular/core";
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { NumberInputComponent } from "@kernel/form/modules/inputs/simple-inputs/components/number-input/number-input.component";
import { SliderInputComponent } from "@kernel/form/modules/inputs/simple-inputs/components/slider-input/slider-input.component";
import { TranslatePipe } from "@ngx-translate/core";
import { CustomInput } from "@kernel/form/classes/custom-input";

@Component({
  selector: "app-range-input",
  imports: [FormsModule, NumberInputComponent, ReactiveFormsModule, SliderInputComponent, TranslatePipe],
  templateUrl: "./range-input.component.html",
  styleUrl: "./range-input.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeInputComponent),
      multi: true,
    },
  ],
})
export class RangeInputComponent extends CustomInput<{ min?: number | null; max?: number | null }> {
  minValue = input<number>(0);
  maxValue = input<number>(100);
  step = input<number>(1);
  ignoreDefaults = input<boolean>(false);
  maxLabel = input<string>("max");
  minLabel = input<string>("min");

  changeMin(value?: number | null) {
    this.value = { ...(this.value ?? {}), min: this.ignoreDefaults() && value === this.minValue() ? undefined : value };
    this.onChange(this.value);
  }

  changeMax(value?: number | null) {
    this.value = { ...(this.value ?? {}), max: this.ignoreDefaults() && value === this.maxValue() ? undefined : value };
    this.onChange(this.value);
  }

  changeRange(value?: number | number[] | null) {
    const min = Array.isArray(value) ? value[0] : value;
    const max = Array.isArray(value) ? value[1] : value;
    this.value = {
      min: this.ignoreDefaults() && min === this.minValue() ? undefined : min,
      max: this.ignoreDefaults() && max === this.maxValue() ? undefined : max,
    };
    this.onChange(this.value);
  }
}
